import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, useMediaQuery, useTheme } from '@mui/material';

import MultiColorPicker from '~/components/atoms/color-picker/MultiColorPicker';
import Accordion from '~/components/ui/Accordion/Accordion';
import Select from '~/components/ui/Select';
import { DESKTOP_MIN_WIDTH, FONTS } from '~/constants/common';
import { useAppDispatch } from '~/hooks/useRedux';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { imagesSlice, updateImagesSiteThunk } from '~/store/reducers/previewScreens/images';
import { getImagesReducer } from '~/store/reducers/previewScreens/images/selectors';

const { actions } = imagesSlice;

export default function Appearance() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const isDesktop = useMediaQuery(theme.breakpoints.up(DESKTOP_MIN_WIDTH));
  const { micrositeData, fonts, bacgkroundColor } = useSelector(getImagesReducer);

  const getReplacedInitialColor = () => {
    if (bacgkroundColor) return bacgkroundColor;
  };

  const handleChangeFonts = (field, value) => {
    dispatch(
      updateImagesSiteThunk({
        id: micrositeData?.id,
        body: {
          fonts: {
            ...fonts,
            [field]: value,
          },
        },
        dispatchHandler: () => dispatch(actions.setFonts({ field, value })),
      }),
    );
  };

  return (
    <CreateQRContentBlockLayout type="appearance">
      <Accordion
        defaultExpanded
        variant="child"
        summary={t('basicTemplateLabels:tmplDesign')}
        details={
          <MultiColorPicker
            setColorValues={(val) => dispatch(actions.setBackgroundColor(val))}
            initialColors={[['#5356FF'], ['#1E88E5'], ['#7B1FA2'], ['#C62828'], ['#EF6C00'], ['#2E7D32']]}
            selectedColors={[micrositeData?.design?.primary]}
            blurFunction={(arr) => {
              if (micrositeData?.id) {
                dispatch(
                  updateImagesSiteThunk({
                    id: micrositeData?.id,
                    body: {
                      design: {
                        primary: arr[0],
                      },
                    },
                  }),
                );
              }
            }}
            onSketchPickerChange={(val) => dispatch(actions.setBackgroundColor(val))}
            getReplacedInitialColor={getReplacedInitialColor}
          />
        }
      />

      <Accordion
        defaultExpanded
        variant="child"
        hideBottomBorder
        summary={t('basicTemplateLabels:tmplFonts')}
        details={
          <Box display="flex" flexDirection={isDesktop ? 'row' : 'column'} sx={{ gap: '16px' }}>
            <Select
              items={FONTS}
              onChange={(e) => handleChangeFonts('title', e.target.value)}
              fullWidth
              label={t('other:title')}
              defaultValue={fonts?.title || FONTS[3].value}
            />
            <Select
              items={FONTS}
              onChange={(e) => handleChangeFonts('text', e.target.value)}
              fullWidth
              label={t('other:text')}
              defaultValue={fonts?.text || FONTS[3].value}
            />
          </Box>
        }
      />
    </CreateQRContentBlockLayout>
  );
}
